import { useState, useEffect } from "react";
import BatteryInterface from "./interface";
import { BatteryState } from "./types";

export const initialState: BatteryState = {
  battery: {
    isCharging: false,
    chargePercent: 0
  }
};

export default () => {
  const [batteryState, setBatteryState] = useState<BatteryState>(initialState);

  useEffect(() => {
    return BatteryInterface.addEventListener(setBatteryState);
  }, []);

  return batteryState;
};
